'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var PEERBOARD_EMBED_SDK_URL = 'https://static.peerboard.com/embed/embed.js';
var trimLeftSlash = function (str) {
    return str.startsWith('/') ? str.substr(1) : str;
};
var forumSDK = null;
var loadingSDK = null;
var loadSdk = function (embedSDKURL) {
    if (forumSDK !== null) {
        return Promise.resolve();
    }
    if (loadingSDK !== null) {
        return loadingSDK;
    }
    return loadingSDK = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = embedSDKURL || PEERBOARD_EMBED_SDK_URL;
        script.setAttribute("async", "");
        script.setAttribute("data-skip-init", "");
        script.onload = function () {
            forumSDK = window.PeerboardSDK;
            resolve();
        };
        script.onerror = function () {
            console.error('failed to download sdk');
            reject();
            loadingSDK = null;
        };
        document.head.append(script);
    });
};
var defaultOptions = {
    resize: true,
    hideMenu: true,
    baseURL: "https://peerboard." + window.document.location.hostname,
    sdkURL: PEERBOARD_EMBED_SDK_URL,
    onTitleChanged: function (title) { return window.document.title = title; },
    onPathChanged: function (newPath) { return window.history.replaceState({}, window.document.title, newPath); }
};
var createForum = function (forumID, container, options) {
    var opts = __assign(__assign({}, defaultOptions), { scrollToTopOnNavigationChanged: true });
    if (!opts.usePathFromQs) {
        // Auto resolve redirect
        opts.path = ((options.prefix && options.prefix !== "/")
            ? document.location.pathname.replace(new RegExp("^/" + trimLeftSlash(options.prefix)), '')
            : document.location.pathname) + document.location.search + document.location.hash;
    }
    Object.assign(opts, options);
    return loadSdk(options.sdkURL).then(function () {
        if (!forumSDK) {
            throw new Error("Forum should be loaded at the moment.");
        }
        return new Promise(function (resolve, reject) {
            var api = forumSDK.createForum(forumID, container, __assign(__assign({}, opts), { onFail: function () {
                    if (opts.onFail) {
                        opts.onFail();
                    }
                    reject(new Error("failed to initialize PeerBoard iframe internals"));
                }, onReady: function () {
                    if (opts.onReady) {
                        opts.onReady();
                    }
                    resolve(api);
                } }));
        });
    }).catch(function (err) {
        console.error("Error creating forum: ", err);
        if (options.onFail) {
            options.onFail();
        }
        throw err;
    });
};

exports.loadSdk = loadSdk;
exports.createForum = createForum;
//# sourceMappingURL=peerboard-core.cjs.js.map
